import { useEffect, useState } from 'react';

const useIsTabActive = () => {
  const isFocus = true;
  const [isTabVisible, setIsTabVisible] = useState(true);

  const handleFocus = () => {
    return setIsTabVisible(isFocus);
  };

  const handleBlur = () => {
    return setIsTabVisible(!isFocus);
  };

  useEffect(() => {
    document.addEventListener('focus', handleFocus);
    window.addEventListener('focus', handleFocus);
    document.addEventListener('blur', handleBlur);
    window.addEventListener('blur', handleBlur);
    return () => {
      document.removeEventListener('focus', handleFocus);
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('blur', handleBlur);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);
  return isTabVisible;
};

export default useIsTabActive;
